//https://medium.com/@parkerjmed/practical-bit-manipulation-in-javascript-bfd9ef6d6c30

import { EncodingType, SortOrder } from "@iotv/iotv-v3-types"

/// byte position to use for start and end 87654321
const debug = false

export const setBitsToNumber = (byte: number, value: number, start: number, end: number) => {
    const ones = (1 << (end - start + 1)) - 1
    const mask = ~(ones << start - 1)
    // reset bits i thru j to one
    byte = byte & mask
    // shift m by i
    value = value << start - 1
    // merge i thru j
    const res = byte | value

    debug && console.log(Object.fromEntries(Object.entries({ byte, ones, mask, value, res }).map(([ k, v ]) => [ k, v.toString(2) ])))
    return res
}

// finds value of mask assuming mask is single set of masked bit positions
export const readNumberAtBytePos = (byte: number, mask: number) => {
    let shiftRight = 0
    let maskClone = mask
    const max = 10
    let i: number = 0
    while (i < max && (maskClone & 0b1) === 0) {
        maskClone = maskClone >> 1
        shiftRight++
        debug && console.log('mask clone', maskClone)
        i++
    }
    debug && console.log('mask', mask.toString(2))
    debug && console.log('byte', byte.toString(2))
    debug && console.log('shift', shiftRight)

    return (byte >> shiftRight) & (mask >> shiftRight)

}

type UInt8ByteMapCodecConstructorProps = {
    /** MSB first ordered map to be used as base for mutation. Normally values whould be zero */
    templateMap: { [ k: string ]: 0 | 1 }

}
type UInt8ByteMapCodecEncodeInput = {}
type UInt8ByteMapCodecDecodeInput = {
    int8Bytes: number
}
export type ByteObjectRepresentation = { [ k: string ]: 0 | 1 }

/** a codec to convert a between bitmap and object representation with a constant template with keys in 0x0000, 0x0001, 0x0002 0x0004 ( increasing value ) order as defined in a spefication -- 
 * Note CORRECT ORDER OF KEYS IN TEMPLATE IS IMPORTANT!
*/
export class UInt8ByteMapCodec {
    constructor({ templateMap }: UInt8ByteMapCodecConstructorProps) {
        const expectedLength = 8
        const baseBin = 0b0

        if (Object.keys(templateMap).length !== expectedLength) { throw new Error(`ByteMap must have ${ expectedLength } keys exactly`) }
        this.extractor = ( objectRepresentation: ByteObjectRepresentation ) => Object.fromEntries( Object.keys( templateMap ).map( ( k ) => [ k, objectRepresentation[k] ?? 0] ))
        this.decode = ({ int8Bytes }) => Object.fromEntries(Object.keys(templateMap).map((k, i) => [ k, (int8Bytes & Math.pow(2, i)) ? 1 : 0 ]))
        this.encode = (objectRepresentation: ByteObjectRepresentation) => Object.values(this.extractor(objectRepresentation)).reduce((a, c, i) => c ? a | Math.pow(2, i) : a, baseBin as number)
    }

    
    extractor: ( objectRepresentation: ByteObjectRepresentation ) =>  ByteObjectRepresentation

    decode: ({ int8Bytes }: UInt8ByteMapCodecDecodeInput) => { [ k: string ]: 0 | 1 }
    encode: (map: { [ k: string ]: 0 | 1 }) => number

}

    
